export default {
  resourceInput: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    padding: 3,
  },
  resourceInputRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  resourceQuantityCol: {
    width: 100,
  },
  resourceActionCol: {
    width: 100,
  }
};



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceSummaryGrid/styles.js